import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import Carousel from 'react-bootstrap/Carousel';
import Button from 'react-bootstrap/Button';
import {useEffect, useState} from 'react'; 

function Slider() {

  const [windowSize, setWindowSize] = useState(getWindowSize());
  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return (
    <div style={{ margin: 'auto', padding: 40 }}>


    <Carousel style={{display:'flex', width:windowSize.innerWidth/2+130,maxHeight: windowSize.innerHeight-120, margin:'auto',background:'#000000'}}>

    <Carousel.Item interval={1500} >
        <img
          className="block w-100 h-100" 
          src="https://res.cloudinary.com/dxr8nm7g8/image/upload/v1668942374/Blue_and_Grey_Traditional_Executive_Real_Estate_Proposal_Mission_and_Goals_Presentation_ijr0ml.png"
          alt=""
        />
     
        <Carousel.Caption>
          <h3></h3>
          <p></p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item interval={1000}>
        <img
          className="block w-100 h-100"
          src="https://res.cloudinary.com/dxr8nm7g8/image/upload/v1668947722/4_nafuk0.jpg"
          alt=""
        />
        <Carousel.Caption>
          <h3></h3>
          <p></p>
        </Carousel.Caption>
      </Carousel.Item>
      
    
      <Carousel.Item interval={1000}>
        <img
          className="block w-100 h-100"
          src="https://res.cloudinary.com/dxr8nm7g8/image/upload/v1668947722/3_tt7ngq.jpg"
          alt="Second slide"
        />

        <Carousel.Caption>
          <h3></h3>
          <p>
            
          </p>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item interval={1000}>
        <img
          className="block w-100 h-100"
          src="https://res.cloudinary.com/dxr8nm7g8/image/upload/v1668947722/2_gqtakg.jpg"
          alt="Third slide"
        />

        <Carousel.Caption>
          <h3></h3>
          <p>
            
          </p>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item interval={1000}>
        <img
          className="block w-100 h-100"
          src="https://res.cloudinary.com/dxr8nm7g8/image/upload/v1668947722/1_aypwmr.jpg"
          alt="Third slide"
        />

        <Carousel.Caption>
          <h3></h3>
          <p>
            
          </p>
        </Carousel.Caption>
      </Carousel.Item>

    </Carousel>
    <div >
     
      

   
   
   
    
           <Button style={{minWidth:160}} variant="primary" href= {"https://instagram.com/iotclub_vnr?igshid=MWI4MTIyMDE="} target="_blank">Follow us on Instagram</Button>
           <h1>&nbsp;&nbsp;</h1>
           <Button style= {{minWidth:160}} svariant="primary" href= {"https://forms.gle/ftgZikTy6zXbZW8m7"} target="_blank">Intrested in IoT - Click Here</Button>
           
           <br/>
           </div>
          
    
    </div>
  );
}

export default Slider;

function getWindowSize() {
  const {innerWidth, innerHeight} = window;
  return {innerWidth, innerHeight};
}